(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Additional-fodMaps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-form-fc')) {
    class ProductFormFc extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-atc-button]');
        this.label = this.querySelector('[data-atc-label]');
        this.defaultLabel = this.label ? this.label.textContent.trim() : 'ADD TO CART';
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit);
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('submit', this.onSubmit);
        }
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.button || this.button.disabled) return;

        const formData = new FormData(this.form);
        this.button.disabled = true;
        this.button.classList.remove('is-added');
        if (this.label) this.label.textContent = 'ADDING...';

        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          if (!response.ok) {
            const errorData = await response.json().catch(function () {
              return {};
            });
            throw new Error(errorData.description || 'Unable to add to cart');
          }

          const item = await response.json();
          this.button.classList.add('is-added');
          if (this.label) this.label.textContent = 'ADDED!';

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { item: item }
            })
          );

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form-fc', productVariantId: item.variant_id });
          }

          fetch(root + 'cart.js')
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } })
              );
            })
            .catch(function () {});

          window.setTimeout(() => {
            this.button.classList.remove('is-added');
            if (this.label) this.label.textContent = this.defaultLabel;
            this.button.disabled = false;
          }, 1800);
        } catch (error) {
          if (this.label) this.label.textContent = 'ERROR';
          window.setTimeout(() => {
            if (this.label) this.label.textContent = this.defaultLabel;
            this.button.disabled = false;
          }, 1800);
        }
      }
    }

    customElements.define('product-form-fc', ProductFormFc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-form-fc')) {
    class ProductFormFc extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('[data-atc-button]');
        this.label = this.querySelector('[data-atc-label]');
        this.defaultLabel = this.label ? this.label.textContent.trim() : 'ADD TO CART';
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit);
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('submit', this.onSubmit);
        }
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.button || this.button.disabled) return;

        const formData = new FormData(this.form);
        this.button.disabled = true;
        this.button.classList.remove('is-added');
        if (this.label) this.label.textContent = 'ADDING...';

        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          if (!response.ok) {
            const errorData = await response.json().catch(function () {
              return {};
            });
            throw new Error(errorData.description || 'Unable to add to cart');
          }

          const item = await response.json();
          this.button.classList.add('is-added');
          if (this.label) this.label.textContent = 'ADDED!';

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { item: item }
            })
          );

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form-fc', productVariantId: item.variant_id });
          }

          fetch(root + 'cart.js')
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } })
              );
            })
            .catch(function () {});

          window.setTimeout(() => {
            this.button.classList.remove('is-added');
            if (this.label) this.label.textContent = this.defaultLabel;
            this.button.disabled = false;
          }, 1800);
        } catch (error) {
          if (this.label) this.label.textContent = 'ERROR';
          window.setTimeout(() => {
            if (this.label) this.label.textContent = this.defaultLabel;
            this.button.disabled = false;
          }, 1800);
        }
      }
    }

    customElements.define('product-form-fc', ProductFormFc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
